/**
 * The resolved page-canvas colour per theme, as a plain hex string.
 *
 * CSS can't reach every surface that needs this. The PWA manifest's
 * `background_color`, the `<meta name="theme-color">` tags, and the Electron
 * BrowserWindow's `backgroundColor` are all painted by the OS or the browser
 * BEFORE our stylesheet exists, so each one needs the value literally. They
 * were previously all pinned to `#0f172a` — a slate navy matching no theme we
 * ship, which is why an installed light-mode POS flashed dark on launch and
 * the Electron window flashed navy in both themes (F-FE-N55, I3/I4).
 *
 * These must stay equal to `--background` in index.css. That is not left to
 * discipline: lib/themeContract.test.ts parses the CSS and fails if they drift.
 */
export const CANVAS_DARK = '#1e1915'
export const CANVAS_LIGHT = '#ffffff'

export type CanvasTheme = 'light' | 'dark' | 'high-contrast'

/** High contrast is a light theme — its --background is 0 0% 100%. */
export function canvasFor(theme: CanvasTheme): string {
  return theme === 'dark' ? CANVAS_DARK : CANVAS_LIGHT
}
